import { Button } from "@k8slens/lds";
import rehypeSanitize from "rehype-sanitize";
import ReactMarkdown from "react-markdown";
import PublicLayout from "src/components/PublicLayout/PublicLayout";
import { useBusiness } from "src/hooks/useBusiness";
import { useGetLicense } from "src/hooks/useGetLicense";
import { useHistory } from "react-router-dom";
import { navigation } from "@k8slens/lds-icons";
import { useBusinessIdParam } from "src/hooks/useBusinessIdParam";

const { CloseIcon } = navigation;

function JoinedOrganizationBody() {
  const businessId = useBusinessIdParam();
  const { business } = useBusiness(businessId);
  const license = useGetLicense();

  return (
    <div>
      <section>
        <p className="leading-normal mt-sm">
          <>You have joined the </>
          <strong>{business?.name}</strong>
          <> organization</>
          <> and have been assigned a </>
          <strong>{license?.type}</strong>
          <> license</>
          <>. Enjoy!</>
        </p>

        <WelcomeMessage emailDomainWelcomeMessage={business?.emailDomainWelcomeMessage ?? ""} />
      </section>
    </div>
  );
}

function WelcomeMessage({ emailDomainWelcomeMessage }: { emailDomainWelcomeMessage: string }) {
  if (!emailDomainWelcomeMessage || emailDomainWelcomeMessage === "") {
    return null;
  }

  return (
    <p className="leading-normal mt-2xl mb-md">
      <h4 className="uppercase mb-sm">Messsage from Your Organization Admin</h4>
      <ReactMarkdown
        rehypePlugins={[rehypeSanitize]}
        allowedElements={["h1", "h2", "h3", "h4", "p", "ul", "li", "ol", "a", "strong", "em", "br"]}
        components={{
          h1: ({ node, ...props }) => <h1 className="lds-h3" {...props} />,
          h2: ({ node, ...props }) => <h2 className="lds-h4" {...props} />,
          h3: ({ node, ...props }) => <h1 className="lds-h5" {...props} />,
          h4: ({ node, ...props }) => <h1 className="lds-h6" {...props} />,
          p: ({ node, ...props }) => <p className="break-words" {...props} />,
          ul: ({ node, ...props }) => <ul className="ml-3.5 my-md pl-0" {...props} />,
          ol: ({ node, ...props }) => <ul className="ml-3.5 my-md list-decimal pl-0" {...props} />,
        }}
      >
        {emailDomainWelcomeMessage}
      </ReactMarkdown>
    </p>
  );
}

export function WelcomeMessagePreview() {
  const history = useHistory();

  return (
    <PublicLayout
      title="Joined Organization"
      size="md"
      wrapperClassName="relative"
      header={
        <button aria-label="Close" title="Close" onClick={() => history.goBack()} className="absolute top-2 right-2">
          <CloseIcon />
        </button>
      }
      footer={
        <div className="flex w-full justify-center my-sm">
          <Button
            textTransform="capitalize"
            label="Get Started"
            primary
            onClick={() => {
              history.goBack();
            }}
          />
        </div>
      }
    >
      <JoinedOrganizationBody />
    </PublicLayout>
  );
}
